<template>
  <div>
    <Breadcrumbs :title="$t('companyUserSectors.faliyytSahlrim')" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12 ">
          <div class="card">
            <div class="card-header">
              <p class="lead">
                {{ $t('companySearch.faliyytSahlri') }}
              </p>
              <p v-if="profile==='PROCUREMENT'">
                {{
                  $t('companyUserSectors.sizinSediyinizFaliyytSahsiSizinNOxSatnAldnzMalxidm', {
                    PARENT_SECTORS: limits.PARENT_SECTORS,
                    SECTORS: limits.SECTORS
                  })
                }}
              </p>
              <p v-else>
                {{
                  $t('companyUserSectors.sizSediyinizTarifPaketinGrLimitsparentsectorsAnaSe', {
                    parent: limits.PARENT_SECTORS,
                    sectors: limits.SECTORS
                  })
                }} <br>{{ $t('companyUserSectors.sizYalnzHrAyBirDfSeilmiTarifZrFaliyytSahlriniziDyi') }}
              </p>
            </div>

            <div
              v-if="editWorkingSectors"
              class="card-body"
            >
              <form @submit.prevent="saveWorkingSectors">
                <div class="mb-3">
                  <SelectedSectorView
                    :sectors="selectedSectors"
                    :parent-id="0"
                  />

                  <a
                    v-b-modal.modal-sector-selection
                    class="btn btn-outline-primary"
                  >
                    {{ $t('companyProfile.faliyytSahsiniSein') }}
                  </a>
                  <br>
                </div>


                <div class="mb-3">
                  <button
                    type="submit"
                    class="btn btn-primary mr-2"
                  >
                    {{ $t('companyProfile.dyiikliyiYaddaSaxla') }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-danger"
                    @click.prevent="editWorkingSectors = false"
                  >
                    {{ $t('companyProfile.lvEt') }}
                  </button>
                </div>
              </form>
            </div>
            <div
              v-else
              class="card-body"
            >
              <SelectedSectorView
                :sectors="sectors"
                :parent-id="0"
              />

              <button
                class="btn btn-sm mt-2 btn-outline-primary d-flex align-items-center px-2"
                @click.prevent="editWorkingSectors = true"
              >
                <feather
                  type="settings"
                  size="16"
                  class="mr-2"
                />
                {{ $t('companyProfile.faliyytSahlriniDyi') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      scrollable
      class="theme-modal"
      :busy="false"
    >
      <sector_selection_modal
        :parent-sector="null"
        :selected="selectedSectors"
        :max-selection="limits.SECTORS"
        :max-parent-selection="limits.PARENT_SECTORS"
        @done="($event)=>{selectedSectors = $event; $bvModal.hide('modal-sector-selection') }"
      />

      <template #modal-footer>
        <div class="text-warning">
          {{
            $t('companyUserSectors.sizAnaSahdnToplamFaliyytSahsiSeBilrsiniz', {
              PARENT_SECTORS: limits.PARENT_SECTORS,
              SECTORS: limits.SECTORS
            })
          }}
        </div>
      </template>
    </b-modal>
  </div>
  <!-- Container-fluid Ends-->
</template>
<script>
import {mapState} from "vuex";
import {
  changeCompanyUserSectors,
  getCompanyUserSectors,
  removeCompanyLogo,
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";

import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";

export default {
  components: {
    SelectedSectorView,
    Sector_selection_modal,
  },
  data() {
    return {
      mediaBase: mediaBase,
      sectors: [],
      allSectors: [],
      selectedSectors: [],
      editWorkingSectors: false,

    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
      limits: state => state.auth.packageLimits
    }),
    companySupplyRating() {
      if (!this.companyDetails || this.companyDetails.supplyRateCount === null || this.companyDetails.supplyRateCount < 1) {
        return 0;
      } else {
        return (this.companyDetails.supplyRateTotal / this.companyDetails.supplyRateCount).toFixed(1);
      }
    },
    companyProcurementRating() {
      if (!this.companyDetails || this.companyDetails.procurementRateCount === null || this.companyDetails.procurementRateCount < 1) {
        return 0;
      } else {
        return (this.companyDetails.procurementRateTotal / this.companyDetails.procurementRateCount).toFixed(1);
      }
    }
  },
  watch: {
    editWorkingSectors(newVal) {
      if (newVal) {
        this.selectedSectors = this.sectors;
      }
    },
  },
  mounted() {

    this.getCompanyUserDetails();

  },
  methods: {

    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getCompanyUserDetails() {
      getCompanyUserSectors(this.token).then(data => {
        if (data.code === 200) {
          this.sectors = data.sectors;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }
      })
    },
    saveWorkingSectors() {
      let sectors = this.selectedSectors.map(function (elem) {
        return elem.id;
      }).join(",")

      changeCompanyUserSectors(this.token, sectors).then(data => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text:  this.$t("flyytShlrDyshdrld"),
            icon: 'success'
          }).then(() => {
            this.editWorkingSectors = false;
            this.getCompanyUserDetails();

            let next = this.$route.query.next;
            if (next) {
              if (next === 'requestDetails') {
                this.$router.push({name: 'request', params: {id: this.$route.query.id}});
              } else if (next === 'subscription') {
                this.$router.push({name: 'subscriptionPage'});
              } else {
                this.$router.push(next)
              }
            }
          })
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },

    removeProfilePhoto() {
      if (confirm(this.$t("sklSlmkIstdyndn"))) {
        removeCompanyLogo(this.token).then(data => {
          if (data.code === 200) {
            this.getCompanyUserDetails();
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    },
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
